import { render, staticRenderFns } from "./ChristmasGarland.vue?vue&type=template&id=04b61b86&scoped=true"
import script from "./ChristmasGarland.vue?vue&type=script&lang=js"
export * from "./ChristmasGarland.vue?vue&type=script&lang=js"
import style0 from "./ChristmasGarland.vue?vue&type=style&index=0&id=04b61b86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b61b86",
  null
  
)

export default component.exports